import React__default from 'react';
import { CartSlider, Cart } from '@grandvisionhq/carts-v2';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { Consents } from '../../Consents/layout/Consents.js';
import { ShippingMethods } from '../../../StepShipping/modules/ShippingMethods/layouts/ShippingMethods.js';
import { ExpressCheckoutFormContainer } from './ExpressCheckoutFormContainer/ExpressCheckoutFormContainer.js';
import { ServiceStoreHeading } from '../../ServiceStore/layout/ServiceStoreHeading.js';
import { ServiceStore } from '../../ServiceStore/layout/ServiceStore.js';
import { ImplicitTermsAndConditionsContainer } from '../../../StepShipping/containers/ImplicitTermsAndConditionsContainer.js';

const ExpressCheckoutUI = ({ shippingMethodsAsides , isNearestPickup ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            expressShipmentMethodTitle: getLabel('checkout.express.shipment.method.title'),
            expressServiceStoreTitle: getLabel('checkout.express.serviceStore.title'),
            expressServiceStoreSubtitle: getLabel('checkout.express.serviceStore.subtitle')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "express-checkout-ui"
    }, /*#__PURE__*/ React__default.createElement(CartSlider, null, /*#__PURE__*/ React__default.createElement(Cart, null)), /*#__PURE__*/ React__default.createElement(ShippingMethods, {
        shippingMethodsAsides: shippingMethodsAsides
    }), isNearestPickup && /*#__PURE__*/ React__default.createElement(Alert, {
        icon: "info",
        message: getLabel('checkout.summary.shipment.nearestPickup.message')
    }), /*#__PURE__*/ React__default.createElement(ExpressCheckoutFormContainer, null), /*#__PURE__*/ React__default.createElement(ServiceStoreHeading, {
        title: labels.expressServiceStoreTitle,
        subtitle: labels.expressServiceStoreSubtitle,
        hideIcon: true
    }), /*#__PURE__*/ React__default.createElement(ServiceStore, null), /*#__PURE__*/ React__default.createElement(Consents, null), /*#__PURE__*/ React__default.createElement(ImplicitTermsAndConditionsContainer, null));
};

export { ExpressCheckoutUI };
//# sourceMappingURL=ExpressCheckoutUI.js.map
